<template>
    <div class="customer-customer-actions">
        <v-card>
            <v-card-text v-if="!loading">
                <div class="title">{{ fullname }}</div>
                <div class="cca-subheading">
                    <span class="subheading font-weight-regular grey--text">{{ email }}</span>
                </div>
            </v-card-text>

            <v-card-text v-if="loading">
                <v-container d-flex align-center justify-center>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
            </v-card-text>
            
            <v-card-actions>
                <v-progress-linear class="mb-2" :indeterminate="true" :active="inAction"></v-progress-linear>
                
                <SetPassword color="success" :disabled="isLoading || inAction" :alternativeBtn="true" :ssoId="ssoId" :fullname="fullname" :email="email" class="mb-2" />
                <ResetPassword :alternativeBtn="true" :ssoId="ssoId" :disabled="isLoading || inAction" class="mb-2" />
                <CustomerEdit :disabled="isLoading || inAction" :alternativeBtn="true" :ssoId="ssoId" />
                <Newsletters :email="email" :disabled="isLoading || inAction" :ssoId="ssoId" />
                <EditEmail :disabled="isLoading || inAction" :alternativeBtn="true" :ssoId="ssoId" />
                <AdHocPurchase @close="reload" :disabled="isLoading || inAction" :alternativeBtn="true" :ssoId="ssoId" class="mb-2" />

                <v-tooltip bottom v-if="hasGp">
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled="isLoading || inAction" :loading="transferPurchasesLoading" class="mb-2 drei_60-btn" @click="transferPurchases" v-on="on">Produkte übertragen</v-btn>
                    </template>
                    <div class="max-width-btn">
                        Erneutes Übertragen aller Produkte aus SAP in CeleraOne.
                    </div>
                </v-tooltip>
                
                <DeleteCustomerBtn class="mb-2" :disabled="isLoading || inAction" :ssoId="ssoId" :alternativeBtn="true" @close="deleteDialogClosed" />
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
    mapState,
} from 'vuex';
import Api from '@/api';
import Route from '@/route';
import EditEmail from '@/components/customer/EditEmail.vue';
import ResetPassword from '@/components/customer/ResetPassword.vue';
import SetPassword from '@/components/customer/SetPassword.vue';
import AdHocPurchase from '@/components/adHocPurchase/AdHocPurchase.vue';
import DeleteCustomerBtn from '@/components/customer/DeleteCustomerBtn.vue';
import CustomerEdit from '@/components/customer/CustomerEdit.vue';
import Newsletters from '@/components/customer/Newsletters.vue';

export default {
    name: 'CustomerActions',
    components: {
        DeleteCustomerBtn,
        AdHocPurchase,
        EditEmail,
        ResetPassword,
        SetPassword,
        CustomerEdit,
        Newsletters,
    },
    computed: {
        ...mapGetters('customerDetail', ['isLoading', 'hasGp', 'fullname', 'email']),
        ...mapState('customerDetail', ['ssoId', 'inAction', 'contractors', 'login', 'masterdataCeleraone']),
        loading() {
            return this.login.loading || this.masterdataCeleraone.loading;
        },
    },
    data() {
        return {
            transferPurchasesLoading: false,
        };
    },
    methods: {
        ...mapMutations('customerDetail', ['setInAction']),
        ...mapActions('customerDetail', ['loadData']),
        deleteDialogClosed(successfullDeleted) {
            if (successfullDeleted) {
                this.$router.push({ name: Route.SEARCH.name });
            } else {
                this.reload();
            }
        },
        reload() {
            this.loadData();
        },
        transferPurchases() {
            this.setInAction(true);
            this.transferPurchasesLoading = true;
            this.$emit('inAction', true);
            Api.customer
                .activateCustomer(this.ssoId)
                .catch(() => null);
            Api.customer
                .transferPurchases(this.ssoId)
                .then(() => {
                    // this.$store.commit('snackbar/success', 'Produkte erfolgreich übertragen.');
                }).catch(() => null) // {
                //    Deaktiviert bis MSP-API verlässlich arbeitet
                //    this.$store.commit('snackbar/error', 'Produktübertragung fehlerhaft.');
                // })
                .finally(() => {
                    this.$store.commit('snackbar/success', 'Produkte erfolgreich übertragen.');
                    this.$router.replace(this.$router.currentRoute.fullPath);
                    this.transferPurchasesLoading = false;
                    this.setInAction(false);
                    this.$emit('inAction', false);
                });
        },
    },
};
</script>

<style scoped lang="scss">
    .customer-customer-actions {
        min-height: 50px;
        .v-card__actions{
            display: flex;
            flex-direction: column;
            .v-btn {
                margin: 0;
            }
        }
    }
    .cca-subheading {
        display: flex;
        align-items: center;
        > span {
            flex: 1;
        }
        > div.v-dialog__container, > div.v-dialog__container + span {
            flex: none;
        }
    }
    .set-password,
    .ad-hoc-purchase,
    .navigation-login-edit,
    .delete-customer-btn,
    .reset-password,
    .v-card__actions button.v-btn,
    .v-tooltip {
        width: 100%;
    }
</style>
